module.exports = __webpack_public_path__ + "img/60000.c58e6610.jpg";